import React, {
    FormEvent,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";
import {useNavigate} from "react-router";
import {Link} from "react-router-dom";
import {LoginAlert} from "../../components/Alerts/LoginAlert";
import OscContext from "../../context/Osc";
import useApi from "../../hooks/useApi";
import {SubmitButton} from "../../Korbantech/components/Buttons/SubmitButton";
import {PasswordInput} from "../../Korbantech/components/Inputs/PasswordInput";
import {TextInput} from "../../Korbantech/components/Inputs/TextInput";
import {Label} from "../../Korbantech/components/Label";
import {BRAND_LOGO} from "../../utils/constants";
import loginOscImage from '../../components/Tela_acesso_OSC.png'

const Login = () => {
    const api = useApi();
    const navigate = useNavigate();

    const [noApproved, setNoApproved] = useState<boolean>();

    const {state: user, setState: setUser} = useContext(OscContext);
    const handleSubmit = useCallback(
        async (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            e.currentTarget.checkValidity();

            const data = new FormData(e.currentTarget);

            await api
                .post<string>("client/auth/login", data)
                .then(async (res) => {
                    const token = res.data;
                    const headers = {
                        Authorization: `Bearer ${token}`,
                    };

                    await api
                        .get("client/me", {headers})
                        .then((res) => {
                            setUser({
                                ...res.data,
                                access_token: token,
                            });
                        })
                        .catch(console.log);
                })
                .catch((err) => {
                    if (err.response.data.error) setNoApproved(true);
                });
        },
        [api, setUser, setNoApproved]
    );

    const useMatchMedia = (mediaQuery: string, initialValue: any) => {
        const [isMatching, setIsMatching] = useState(initialValue)
        useEffect(() => {
            const watcher = window.matchMedia(mediaQuery)
            setIsMatching(watcher.matches)
            const listener = (matches: { matches: any; }) => {
                setIsMatching(matches.matches)
            }
            if (watcher.addEventListener) {
                watcher.addEventListener('change', listener)
            } else {
                watcher.addListener(listener)
            }
            return () => {
                if (watcher.removeEventListener) {
                    return watcher.removeEventListener('change', listener)
                } else {
                    return watcher.removeListener(listener)
                }
            }
        }, [mediaQuery])

        return isMatching
    }

    const isDesktopResolution = useMatchMedia('(min-width:600px)', true)

    useEffect(() => {
        if (user) navigate("/osc");
    }, [user, navigate]);

    return (
        <div className={isDesktopResolution ? "w-screen grid grid-cols-2" : "w-screen"}>
            {noApproved && (
                <LoginAlert
                    header={"Cadastro aguardando aprovação"}
                    error
                    text={
                        <>
                            Os cadastros passam por uma averiguação e podem
                            levar até 3 dias úteis para serem aprovados,caso já
                            tenha passado o prazo, ou tenha outras dúvidas,
                            favor entrar em contato com &nbsp;
                            <strong>suporte@impulso.com.br</strong>
                        </>
                    }
                />
            )}
            {isDesktopResolution && (<div className="h-screen bg-primary flex border-r-2 border-primary shadow-md">
                <img className="object-contain" src={loginOscImage} width={"100%"} alt={"description"}/>
            </div>)}
            <div className="h-screen w-full flex flex-col items-center justify-center">
                <form
                    className="w-7/12 flex flex-col items-center"
                    onSubmit={handleSubmit}
                >
                    <div className="w-full flex flex-col items-center justify-center ">
                        <img
                            className=""
                            width={170}
                            height="auto"
                            src={BRAND_LOGO}
                            alt="programa impulso"
                        />
                        <p className="text-gray-700 text-lg text-center -mt-9 mb-3 w-11/12">
                            Essa área é exclusiva para participantes do &nbsp;
                            <strong>Projeto Impulso</strong>.
                            Não é cadastrado?
                            <Link
                                className="text-primary-dark ml-1 font-semibold"
                                to={"/osc/registro"}
                            >
                                Criar Conta
                            </Link>
                        </p>
                    </div>
                    <div className="w-9/12 flex flex-col ">
                        <Label>
                            CNPJ
                            <TextInput
                                className={
                                    "border-gray-500 rounded-lg border-gray- shadow-sm"
                                }
                                placeholder={"00.000.000/0001-00"}
                                name="document"
                                required
                            />
                        </Label>
                        <Label>
                            Senha
                            <PasswordInput
                                name="password"
                                className="border-gray-500 shadow-sm rounded-lg"
                                placeholde={"*****"}
                                required
                            />
                            <Link
                                to={"/osc/esqueci-senha"}
                                className="text-sm my-2 font-semibold text-primary-dark"
                            >
                                Esqueceu a senha?
                            </Link>
                        </Label>
                        <SubmitButton
                            className="bg-brand-button text-brand-button-text mt-2"
                            value="Login"
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
